import React, { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  ArrowUpRightIcon,
  BuildingOfficeIcon,
  PlusIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import OrgDropdown from "components/OrgPages/OrgDropdown";
import OrgPageSettings from "components/OrgPages/OrgPageSettings";
import { OrgContext } from "contexts/OrgContext";
import { Button } from "components/Graphs/Button";
import { AddOrgModal } from "components/Modals/AddOrgModel";
import { OneClickDeployContext } from "contexts/OneClickDeployContext";
import { BillingContext } from "contexts/BillingContext";
import { useHistory } from "react-router-dom";
import { displayGpuHours } from "components/utils";
import GPUHoursBalance from "components/GPUHoursBalance";

const Balance: React.FC = (props) => {
  const billingContext = useContext(BillingContext);
  const [gpuHoursBalance, setGpuHoursBalance] = useState<string>("0 GPU hours");
  const history = useHistory();
  const [loadingGpuHoursRange, setLoadingGpuHoursRange] = useState<boolean>(false);
  const orgContext = useContext(OrgContext);

  useEffect(() => {
    if (orgContext.currencyDisplay === "credits") {
      return;
    }
    setLoadingGpuHoursRange(true);

    const rangeStart = displayGpuHours(billingContext.gpuHoursMostExpensive);
    if (billingContext.gpuHoursMostExpensive < 0) {
      setGpuHoursBalance("<1 GPU hour");
    } else if (
      billingContext.gpuHoursLeastExpensive === 0 ||
      billingContext.gpuHoursMostExpensive ===
        billingContext.gpuHoursLeastExpensive
    ) {
      // Org has > 0 credits, but not enough to run any instances
      setGpuHoursBalance(`${rangeStart} GPU hours`);
    } else {
      const rangeEnd = displayGpuHours(billingContext.gpuHoursLeastExpensive);
      setGpuHoursBalance(`${rangeStart}-${rangeEnd} GPU hours`);
    }

    setLoadingGpuHoursRange(false);
  }, [billingContext.gpuHoursMostExpensive, billingContext.gpuHoursLeastExpensive]);

  return (
    <>
      <div
        className="flex flex-row items-center text-secondary border border-secondary rounded-md p-[6px] border-zinc-800 px-2 cursor-pointer"
        onClick={() => {
          history.push(`/org/billing?openAddCredits=true`);
        }}
      >
        {billingContext.currentBalance > 0 && !loadingGpuHoursRange ? (
          <span className="text-xs font-mono text-secondary hover:text-highlight">
            {orgContext.currencyDisplay === "credits" &&
              billingContext.currentBalance.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            {orgContext.currencyDisplay === "hours" && (
              <GPUHoursBalance
                balanceRange={gpuHoursBalance}
                leastExpensiveInstanceType={
                  orgContext.leastExpensiveAvailableInstance?.type || ""
                }
                maxBalance={billingContext.gpuHoursLeastExpensive}
                minBalance={billingContext.gpuHoursMostExpensive}
                mostExpensiveInstanceType={
                  orgContext.mostExpensiveAvailableInstance?.type || ""
                }
              />
            )}
          </span>
        ) : (
          <>
            {billingContext.currentBalance === 0 ? (
              <span className="text-xs font-mono flex flex-row items-center hover:text-highlight">
                Add Credits <ArrowUpRightIcon className="w-3 h-3 ml-[1px]" />
              </span>
            ) : (
              <span className="text-xs font-mono">
                <span className="text-xs  text-red-500 font-mono flex flex-row items-center">
                  {billingContext.currentBalance.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </span>
              </span>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Balance;
